
const digest = '1bc5c3f2b4027259593e6e6fb70fca0b5b355dfbbb122ebb016951e965383bea';
const classes = {"loader":"_loader_1m1zp_1","l7":"_l7_1m1zp_1","background":"_background_1m1zp_21"};
const css = `._loader_1m1zp_1 {
  width: 50px;
  aspect-ratio: 5;
  --_g: no-repeat radial-gradient(circle closest-side, #bbc5cc 90%,#0000);
  background: var(--_g) 0% 50%, var(--_g) 50% 50%, var(--_g) 100% 50%;
  background-size: 33.3333333333% 100%;
  animation: _l7_1m1zp_1 1s infinite linear;
}

@keyframes _l7_1m1zp_1 {
  33% {
    background-size: 33.3333333333% 0%, 33.3333333333% 100%, 33.3333333333% 100%;
  }
  50% {
    background-size: 33.3333333333% 100%, 33.3333333333% 0%, 33.3333333333% 100%;
  }
  66% {
    background-size: 33.3333333333% 100%, 33.3333333333% 100%, 33.3333333333% 0%;
  }
}
._background_1m1zp_21 {
  background-color: #fbfbfd;
  padding: 0 24px;
  margin-top: -20px;
  height: 54px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  